module.exports = __webpack_public_path__ + "static/img/punch-icon.8910fe1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/Pages/Agree/img/desc/punch-icon.png
// module id = 164
// module chunks = 0